"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6309],{

/***/ 23774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardBody = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-df4f0a61-0"
}).withConfig({
    componentId: "sc-657c9e-0"
})(_templateObject(), styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardBody.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardBody);


/***/ }),

/***/ 87654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87379);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57247);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var CardHeader = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-e97edbbd-0"
}).withConfig({
    componentId: "sc-206fd2b9-0"
})(_templateObject(), function(param) {
    var theme = param.theme, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant;
    return theme.card.cardHeaderBackground[variant];
}, function(param) {
    var theme = param.theme;
    return "".concat(theme.radii.card, " ").concat(theme.radii.card, " 0 0");
}, styled_system__WEBPACK_IMPORTED_MODULE_1__/* .space */ .Dh);
CardHeader.defaultProps = {
    p: "24px"
};
/* harmony default export */ __webpack_exports__["Z"] = (CardHeader);


/***/ }),

/***/ 44482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ PageHeader_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Box.tsx
var Box = __webpack_require__(44850);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(55027);
;// CONCATENATED MODULE: ./src/components/PageHeader/PageHeader.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-top: 32px;\n  padding-bottom: 32px;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var Outer = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
    componentId: "sc-1b6d10b3-0"
})(_templateObject(), function(param) {
    var theme = param.theme, background = param.background;
    return background || theme.colors.gradients.bubblegum;
});
var Inner = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-1b6d10b3-1"
})(_templateObject1());
var PageHeader = function(_param) /*#__PURE__*/ {
    var background = _param.background, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "background",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(Outer, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        background: background
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Inner, {
            children: children
        })
    }));
};
/* harmony default export */ var PageHeader_PageHeader = (PageHeader);

;// CONCATENATED MODULE: ./src/components/PageHeader/index.ts




/***/ }),

/***/ 57164:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCatchTxError; },
  "n": function() { return /* binding */ parseError; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/base.js
var base = __webpack_require__(69977);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/errors/rpc.js
var rpc = __webpack_require__(42455);
// EXTERNAL MODULE: ./src/components/Toast/index.tsx + 14 modules
var Toast = __webpack_require__(71999);
// EXTERNAL MODULE: ./src/hooks/useToast.ts
var useToast = __webpack_require__(789);
// EXTERNAL MODULE: ./src/utils/sentry.ts
var sentry = __webpack_require__(17226);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/config/chains.ts
var chains = __webpack_require__(38512);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/createPublicClient.js + 41 modules
var createPublicClient = __webpack_require__(6146);
// EXTERNAL MODULE: ./node_modules/viem/dist/esm/clients/transports/http.js
var http = __webpack_require__(27436);
// EXTERNAL MODULE: ./node_modules/@wagmi/core/dist/chunk-LAFZBYO7.js + 7 modules
var chunk_LAFZBYO7 = __webpack_require__(40032);
// EXTERNAL MODULE: ./src/hooks/useActiveChainId.ts
var useActiveChainId = __webpack_require__(62349);
;// CONCATENATED MODULE: ./src/hooks/usePublicNodeWaitForTransaction.ts










var viemClientsPublicNodes = chains/* CHAINS.reduce */.zG.reduce(function(prev, cur) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, cur.id, (0,createPublicClient/* createPublicClient */.v)({
        chain: cur,
        transport: (0,http/* http */.d)(cur.rpcUrls.public.http[0], {
            timeout: 15000
        }),
        batch: {
            multicall: {
                batchSize: 1024 * 200
            }
        }
    })));
}, {});
function usePublicNodeWaitForTransaction() {
    var chainId = (0,useActiveChainId/* useActiveChainId */.gi)().chainId;
    var waitForTransaction_ = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(opts) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!viemClientsPublicNodes[chainId]) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", viemClientsPublicNodes[chainId].waitForTransactionReceipt(opts));
                    case 2:
                        return _ctx.abrupt("return", (0,chunk_LAFZBYO7/* waitForTransaction */.Mn)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, opts), {
                            chainId: chainId
                        })));
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(opts) {
            return _ref.apply(this, arguments);
        };
    }(), [
        chainId
    ]);
    return {
        waitForTransaction: waitForTransaction_
    };
}

;// CONCATENATED MODULE: ./src/hooks/useCatchTxError.tsx
/* provided dependency */ var process = __webpack_require__(34155);











/// only show corrected parsed viem error
function parseError(err) {
    if ((0,_instanceof/* default */.Z)(err, base/* BaseError */.G)) {
        return err;
    }
    if (typeof err === "string") {
        return new rpc/* UnknownRpcError */.ir(new Error(err));
    }
    if ((0,_instanceof/* default */.Z)(err, Error)) {
        return new rpc/* UnknownRpcError */.ir(err);
    }
    return null;
}
// -32000 is insufficient funds for gas * price + value
var isGasEstimationError = function(err) {
    var ref;
    return (err === null || err === void 0 ? void 0 : (ref = err.data) === null || ref === void 0 ? void 0 : ref.code) === -32000;
};
var notPreview = process.env.NEXT_PUBLIC_VERCEL_ENV !== "preview";
function useCatchTxError() {
    var t = (0,src/* useTranslation */.$G)().t;
    var ref = (0,useToast/* default */.Z)(), toastError = ref.toastError, toastSuccess = ref.toastSuccess;
    var ref1 = (0,react.useState)(false), loading = ref1[0], setLoading = ref1[1];
    var waitForTransaction = usePublicNodeWaitForTransaction().waitForTransaction;
    var ref2 = (0,react.useState)(false), txResponseLoading = ref2[0], setTxResponseLoading = ref2[1];
    var handleNormalError = (0,react.useCallback)(function(error) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        if (err) {
            toastError(t("Error"), t("Transaction failed with error: %reason%", {
                reason: notPreview ? error.shortMessage || error.message : error.message
            }));
        } else {
            toastError(t("Error"), t("Please try again. Confirm the transaction and make sure you are paying enough gas!"));
        }
    }, [
        t,
        toastError
    ]);
    var handleTxError = (0,react.useCallback)(function(error, hash) {
        (0,sentry/* logError */.H)(error);
        var err = parseError(error);
        toastError(t("Failed"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
            txHash: hash,
            children: err ? t("Transaction failed with error: %reason%", {
                reason: notPreview ? err.shortMessage || err.message : err.message
            }) : t("Transaction failed. For detailed error message:")
        }));
    }, [
        t,
        toastError
    ]);
    var fetchWithCatchTxError = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash, receipt;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        _ctx.next = 10;
                        return waitForTransaction({
                            hash: hash
                        });
                    case 10:
                        receipt = _ctx.sent;
                        return _ctx.abrupt("return", receipt);
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 17:
                        _ctx.prev = 17;
                        setLoading(false);
                        return _ctx.finish(17);
                    case 20:
                        return _ctx.abrupt("return", null);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    14,
                    17,
                    20
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        waitForTransaction,
        handleNormalError,
        handleTxError
    ]);
    var fetchTxResponse = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(callTx) {
            var tx, hash;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        tx = null;
                        _ctx.prev = 1;
                        setTxResponseLoading(true);
                        _ctx.next = 5;
                        return callTx();
                    case 5:
                        /**
         * https://github.com/vercel/swr/pull/1450
         *
         * wait for useSWRMutation finished, so we could apply SWR in case manually trigger tx call
         */ tx = _ctx.sent;
                        hash = typeof tx === "string" ? tx : tx.hash;
                        toastSuccess("".concat(t("Transaction Submitted"), "!"), /*#__PURE__*/ (0,jsx_runtime.jsx)(Toast/* ToastDescriptionWithTx */.YO, {
                            txHash: hash
                        }));
                        return _ctx.abrupt("return", {
                            hash: hash
                        });
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](1);
                        if (!(0,sentry/* isUserRejected */.Z)(_ctx.t0)) {
                            if (!tx) {
                                handleNormalError(_ctx.t0);
                            } else {
                                handleTxError(_ctx.t0, typeof tx === "string" ? tx : tx.hash);
                            }
                        }
                    case 14:
                        _ctx.prev = 14;
                        setTxResponseLoading(false);
                        return _ctx.finish(14);
                    case 17:
                        return _ctx.abrupt("return", null);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function(callTx) {
            return _ref.apply(this, arguments);
        };
    }(), [
        toastSuccess,
        t,
        handleNormalError,
        handleTxError
    ]);
    return {
        fetchWithCatchTxError: fetchWithCatchTxError,
        fetchTxResponse: fetchTxResponse,
        loading: loading,
        txResponseLoading: txResponseLoading
    };
};


/***/ }),

/***/ 17226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ logError; },
/* harmony export */   "Z": function() { return /* binding */ isUserRejected; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82670);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92876);
/* harmony import */ var viem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42455);



var assignError = function(maybeError) {
    if (typeof maybeError === "string") {
        return new Error(maybeError);
    }
    if (typeof maybeError === "object") {
        var ref;
        var error = new Error((ref = maybeError === null || maybeError === void 0 ? void 0 : maybeError.message) !== null && ref !== void 0 ? ref : String(maybeError));
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.stack) {
            error.stack = maybeError.stack;
        }
        if (maybeError === null || maybeError === void 0 ? void 0 : maybeError.code) {
            error.name = maybeError.code;
        }
        return error;
    }
    return maybeError;
};
var possibleRejectMessage = [
    "Cancelled by User",
    "cancel",
    "Transaction was rejected"
];
var isUserRejected = function(err) {
    // provider user rejected error code
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UserRejectedRequestError */ .ab)) {
        return true;
    }
    if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(err, viem__WEBPACK_IMPORTED_MODULE_1__/* .UnknownRpcError */ .ir)) {
        // fallback for some wallets that don't follow EIP 1193, trust, safe
        if (possibleRejectMessage.some(function(msg) {
            var ref;
            return (ref = err.details) === null || ref === void 0 ? void 0 : ref.includes(msg);
        })) {
            return true;
        }
    }
    // fallback for raw rpc error code
    if (typeof err === "object") {
        if ("code" in err && (err.code === 4001 || err.code === "ACTION_REJECTED") || "cause" in err && "code" in err.cause && err.cause.code === 4001) {
            return true;
        }
        if ("cause" in err) {
            return isUserRejected(err.cause);
        }
    }
    return false;
};
var ENABLED_LOG = false;
var logError = function(error) {
    if (ENABLED_LOG) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(error, Error)) {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(error);
        } else {
            (0,_sentry_nextjs__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(assignError(error), error);
        }
    }
    console.error(error);
};


/***/ }),

/***/ 87425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38144);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87654);
/* harmony import */ var _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97114);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  max-width: 80px;\n  min-width: 72px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-self: baseline;\n  position: relative;\n  border-radius: 12px;\n  color: ",
        ";\n  \n  & > div {\n    border-radius: 12px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n  background: ",
        ";\n  border-radius: 8px;\n  padding: 5px 5px 2px;\n  position: relative;\n\n  ",
        ":last-child {\n    padding: 8px;\n    line-height: 1.2;\n  }\n\n  &:hover {\n    opacity: .6;\n  }\n\n  img {\n    opacity: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: auto;\n  border-radius: 12px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 4px;\n  right: 4px;\n  border-radius: 16px;\n  padding: 2px 6px;\n  font-size: 14px;\n  background: #1e1a1abf;\n  color: #fff;\n  font-weight: normal;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c3ac2248-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.secondary;
});
var Wrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
    componentId: "sc-c3ac2248-1"
})(_templateObject1(), function(param) {
    var selected = param.selected, background = param.background, theme = param.theme;
    return selected ? "linear-gradient(111.68deg,#420b48 0%,#9bb8f9 100%)" : theme.colors.gradients[background];
}, _pancakeswap_uikit__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, function(param) {
    var selected = param.selected;
    return selected ? ".7" : "1";
});
var StyledAvatarImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c3ac2248-2"
})(_templateObject2());
var StyledTag = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].h2.withConfig */ .ZP.h2.withConfig({
    componentId: "sc-c3ac2248-3"
})(_templateObject3());
var NftItem = function(param) {
    var id = param.id, image = param.image, selected = param.selected, setSelected = param.setSelected;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCard, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Wrapper, {
            selected: selected,
            onClick: function() {
                if (setSelected) setSelected(!selected);
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAvatarImage, {
                    src: "".concat(image)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTag, {
                    children: "#".concat(id)
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NftItem);


/***/ }),

/***/ 26432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FJ": function() { return /* binding */ getRaritiesAndProofs; },
/* harmony export */   "he": function() { return /* binding */ getLockApr; },
/* harmony export */   "lR": function() { return /* binding */ getStatus; }
/* harmony export */ });
/* harmony import */ var config_constants_nfts_merkle_rarity_merkle_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66893);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62039);


var getStatus = function(currentTime, lockStartTime, lockDuration) {
    // Add an extra check to currentBlock because it takes awhile to fetch so the initial value is 0
    // making the UI change to an inaccurate status
    if (lockStartTime === 0) {
        return "locked";
    }
    if (currentTime < lockStartTime + lockDuration) {
        return "locked";
    }
    return "finished";
};
var getLockApr = function(aprRates, boostRates, duration, nfts) {
    if (!_types__WEBPACK_IMPORTED_MODULE_1__/* .LockDuration */ .v[duration]) return 0;
    var baseApr = aprRates[_types__WEBPACK_IMPORTED_MODULE_1__/* .LockDuration */ .v[duration]];
    for(var i = 0; i < nfts.length; i++){
        var ref, ref1;
        var rarity = (ref = config_constants_nfts_merkle_rarity_merkle_json__WEBPACK_IMPORTED_MODULE_0__/* .claims */ .W_) === null || ref === void 0 ? void 0 : (ref1 = ref[nfts[i]]) === null || ref1 === void 0 ? void 0 : ref1.rarity;
        if (rarity >= 0) baseApr += boostRates[rarity];
    }
    return baseApr / 100;
};
var getRaritiesAndProofs = function(nfts) {
    var rarities = nfts.map(function(nft) {
        var ref, ref1;
        return (ref = config_constants_nfts_merkle_rarity_merkle_json__WEBPACK_IMPORTED_MODULE_0__/* .claims */ .W_) === null || ref === void 0 ? void 0 : (ref1 = ref[nft]) === null || ref1 === void 0 ? void 0 : ref1.rarity;
    });
    var proofs = nfts.map(function(nft) {
        var ref, ref1;
        return (ref = config_constants_nfts_merkle_rarity_merkle_json__WEBPACK_IMPORTED_MODULE_0__/* .claims */ .W_) === null || ref === void 0 ? void 0 : (ref1 = ref[nft]) === null || ref1 === void 0 ? void 0 : ref1.proof;
    });
    return {
        rarities: rarities,
        proofs: proofs
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = (null);


/***/ }),

/***/ 72083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B4": function() { return /* binding */ CandyLockLayout; },
  "Jw": function() { return /* binding */ CandyLockV2Layout; },
  "xd": function() { return /* binding */ CandyLockV2MarketLayout; },
  "dg": function() { return /* binding */ CandyLockV3Layout; },
  "j2": function() { return /* binding */ CandyLockV3MarketLayout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Heading/Heading.tsx + 1 modules
var Heading = __webpack_require__(59750);
// EXTERNAL MODULE: ./packages/uikit/src/components/Button/Button.tsx + 2 modules
var Button = __webpack_require__(96293);
// EXTERNAL MODULE: ./packages/uikit/src/components/Link/Link.tsx
var Link = __webpack_require__(80421);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx
var src = __webpack_require__(95963);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 1 modules
var Page = __webpack_require__(83559);
// EXTERNAL MODULE: ./src/components/PageHeader/index.ts + 1 modules
var PageHeader = __webpack_require__(44482);
// EXTERNAL MODULE: ./src/components/Layout/Container.tsx
var Container = __webpack_require__(55027);
;// CONCATENATED MODULE: ./src/views/CandyLock/contexts/IfoContext.tsx


var IfoContext = /*#__PURE__*/ (0,react.createContext)(null);
function useConfig() {
    return useContext(IfoContext);
}
function IfoProvider(param) {
    var children = param.children;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IfoContext.Provider, {
        value: {
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/views/CandyLock/index.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 8px;\n  padding-right: 8px;\n\n  ",
        " {\n    padding-left: 24px;\n    padding-right: 24px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var StyledContainer = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
    componentId: "sc-ed35051b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.mediaQueries.sm;
});
var CandyLockLayout = function(param) {
    var children = param.children;
    var t = (0,src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    style: {
                        gap: "8px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        flex: "1",
                        flexDirection: "column",
                        mr: [
                            "8px",
                            0
                        ],
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                as: "h1",
                                scale: "xxl",
                                color: "secondary",
                                mb: "24px",
                                children: t("Candy Lock")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                scale: "lg",
                                color: "text",
                                children: t("Lock candy token and nft to earn long-term rewards.")
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: children
                })
            })
        ]
    });
};
var CandyLockV2Layout = function(param) {
    var children = param.children;
    var t = (0,src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    style: {
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flex: "1",
                            flexDirection: "column",
                            mr: [
                                "8px",
                                0
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h1",
                                    scale: "xxl",
                                    color: "secondary",
                                    mb: "24px",
                                    children: t("Candy Lock V2")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    scale: "lg",
                                    color: "text",
                                    children: t("Lock candy token and nft to earn long-term rewards.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            flexDirection: "column",
                            style: {
                                gap: "6px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                style: {
                                    width: "100%"
                                },
                                variant: "secondary",
                                scale: "md",
                                as: Link/* default */.Z,
                                href: "/candylock/v2/market",
                                children: "Purchase Lock"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: children
                })
            })
        ]
    });
};
var CandyLockV2MarketLayout = function(param) {
    var children = param.children;
    var t = (0,src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    style: {
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flex: "1",
                            flexDirection: "column",
                            mr: [
                                "8px",
                                0
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h1",
                                    scale: "xxl",
                                    color: "secondary",
                                    mb: "24px",
                                    children: t("Candy Lock V2")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    scale: "lg",
                                    color: "text",
                                    children: t("Buy the listed lock and earn long-term rewards.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            flexDirection: "column",
                            style: {
                                gap: "6px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                style: {
                                    width: "100%"
                                },
                                variant: "secondary",
                                scale: "md",
                                as: Link/* default */.Z,
                                href: "/candylock/v2",
                                children: "Back to Locks"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: children
                })
            })
        ]
    });
};
var CandyLockV3Layout = function(param) {
    var children = param.children;
    var t = (0,src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    style: {
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flex: "1",
                            flexDirection: "column",
                            mr: [
                                "8px",
                                0
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h1",
                                    scale: "xxl",
                                    color: "secondary",
                                    mb: "24px",
                                    children: t("Candy Lock V3")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    scale: "lg",
                                    color: "text",
                                    children: t("Lock candy token and nft to earn long-term rewards.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            style: {
                                gap: "6px"
                            },
                            children: [
                                router.route === "/candylock/v3/create" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    scale: "md",
                                    as: Link/* default */.Z,
                                    href: "/candylock/v3",
                                    children: "Back to Locks"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    scale: "md",
                                    as: Link/* default */.Z,
                                    href: "/candylock/v3/create",
                                    children: "Create New Lock"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        width: "100%"
                                    },
                                    variant: "secondary",
                                    scale: "md",
                                    as: Link/* default */.Z,
                                    href: "/candylock/v3/market",
                                    children: "Purchase Lock"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: children
                })
            })
        ]
    });
};
var CandyLockV3MarketLayout = function(param) {
    var children = param.children;
    var t = (0,src/* useTranslation */.$G)().t;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IfoProvider, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "space-between",
                    flexDirection: [
                        "column",
                        null,
                        null,
                        "row"
                    ],
                    alignItems: "center",
                    style: {
                        gap: "8px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flex: "1",
                            flexDirection: "column",
                            mr: [
                                "8px",
                                0
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    as: "h1",
                                    scale: "xxl",
                                    color: "secondary",
                                    mb: "24px",
                                    children: t("Candy Lock V3")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                    scale: "lg",
                                    color: "text",
                                    children: t("Buy the listed lock and earn long-term rewards.")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            flexDirection: "column",
                            style: {
                                gap: "6px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "secondary",
                                    scale: "md",
                                    as: Link/* default */.Z,
                                    href: "/candylock/v3/create",
                                    children: "Create New Lock"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    style: {
                                        width: "100%"
                                    },
                                    variant: "secondary",
                                    scale: "md",
                                    as: Link/* default */.Z,
                                    href: "/candylock/v3",
                                    children: "Back to Locks"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledContainer, {
                    children: children
                })
            })
        ]
    });
};


/***/ }),

/***/ 62039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ LockDuration; }
/* harmony export */ });
var LockDuration;
(function(LockDuration) {
    LockDuration[LockDuration["3 months"] = 7776000] = "3 months";
    LockDuration[LockDuration["6 months"] = 15552000] = "6 months";
    LockDuration[LockDuration["1 year"] = 31536000] = "1 year";
    LockDuration[LockDuration["2 years"] = 63072000] = "2 years";
})(LockDuration || (LockDuration = {}));


/***/ })

}]);